import React from 'react';
import { useAuth } from '../App';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { Clock, Mail, ArrowLeft } from 'lucide-react';

// Logo Component
const Logo = ({ size = "default" }) => {
  const sizeClasses = {
    small: "w-10 h-10",
    default: "w-14 h-14",
    large: "w-20 h-20"
  };
  
  return (
    <div className={`${sizeClasses[size]} relative logo-atom`}>
      <svg viewBox="0 0 100 100" className="w-full h-full">
        <circle cx="50" cy="50" r="45" fill="none" stroke="#1E3A8A" strokeWidth="2" opacity="0.3"/>
        <ellipse cx="50" cy="50" rx="35" ry="20" fill="none" stroke="#1E3A8A" strokeWidth="2" transform="rotate(-30 50 50)"/>
        <ellipse cx="50" cy="50" rx="35" ry="20" fill="none" stroke="#F59E0B" strokeWidth="2" transform="rotate(30 50 50)"/>
        <ellipse cx="50" cy="50" rx="35" ry="20" fill="none" stroke="#1E40AF" strokeWidth="2" transform="rotate(90 50 50)"/>
        <circle cx="50" cy="50" r="8" fill="#1E3A8A"/>
        <circle cx="50" cy="50" r="4" fill="#F59E0B"/>
        <circle cx="85" cy="50" r="4" fill="#F59E0B"/>
        <circle cx="15" cy="50" r="4" fill="#1E3A8A"/>
        <circle cx="50" cy="15" r="4" fill="#1E40AF"/>
        <circle cx="50" cy="85" r="4" fill="#F59E0B"/>
      </svg>
    </div>
  );
};

const PendingApproval = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-[#FDFBF7] flex items-center justify-center p-6">
      <Card className="max-w-md w-full shadow-lg border-slate-200" data-testid="pending-approval-card">
        <CardContent className="p-8">
          <div className="text-center">
            <div className="flex justify-center mb-6">
              <Logo size="large" />
            </div>
            
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Clock className="w-8 h-8 text-yellow-600" />
            </div>
            
            <h1 className="text-2xl font-bold text-[#0F172A] mb-2" style={{ fontFamily: 'Playfair Display, serif' }}>
              Pending Approval
            </h1>
            
            <p className="text-slate-600 mb-6">
              Your account is awaiting administrator approval. You'll receive access once approved.
            </p>

            <div className="bg-slate-50 rounded-lg p-4 mb-6">
              <div className="flex items-center gap-3 text-left">
                <div className="w-10 h-10 bg-[#1E3A8A]/10 rounded-full flex items-center justify-center flex-shrink-0">
                  <Mail className="w-5 h-5 text-[#1E3A8A]" />
                </div>
                <div>
                  <p className="text-sm text-slate-500">Registered as</p>
                  <p className="font-medium text-slate-900">{user?.email}</p>
                </div>
              </div>
            </div>

            <div className="space-y-3">
              <p className="text-sm text-slate-500">
                The administrator has been notified of your registration request.
              </p>
              
              <Button 
                variant="outline" 
                onClick={logout}
                className="w-full"
                data-testid="logout-btn"
              >
                <ArrowLeft className="w-4 h-4 mr-2" />
                Back to Home
              </Button>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default PendingApproval;
